export default {"src":"/_next/static/media/facebook.a06ddb27.svg","height":20,"width":10,"blurWidth":0,"blurHeight":0};